import postal from 'japan-postal-code-oasis'

export type PostalCodeAddressProps = {
  prefecture: string
  city: string
  area: string
  street: string
}

const codeToAddress: (
  code: string,
  path?: string
) => Promise<PostalCodeAddressProps> = (code, path) => {
  postal.configure(path || '/zipdata/')
  return postal(code)
}

export const transformToNumber = (string?: string | number) => {
  if (!string || typeof string === 'number') return
  return string
    .replace(/[０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    })
    .replace(/[^0-9]/g, '');
}

const postalCodeToAddress = (postalCode?: string | number) => ({
  success,
  notFound,
  error,
}: {
  success: (address: PostalCodeAddressProps) => void
  notFound: () => void
  error?: () => void
}) => {
  const number = transformToNumber(postalCode)
  number &&
    codeToAddress(number)
      .then((address: PostalCodeAddressProps) => {
        address ? success(address) : notFound()
      })
      .catch(error)
}

export default postalCodeToAddress
